/**
 * Free room calendar
 */
export class CalendarComponent {

    constructor() {
        this.container = undefined;
        this.init();
    }

    init() {
        this.initCalendarPaginationEvents();
    }

    /**
     * Init event listening
     */
    initCalendarPaginationEvents() {
        this.getContainer()
            .find('.calendar .calendar__prev, .calendar .calendar__next')
            .on('click.calendar', (event) => {
                if(!$(event.currentTarget).hasClass('calendar__pagination-inactive')) {
                    const calendar = $(event.currentTarget).closest('.calendar');
                    const direction = $(event.currentTarget).hasClass('calendar__next') ? 'next' : 'prev';
                    this.calendarPaginate(calendar, direction);
                }
        });
    }

    /**
     * Pagination of calendar
     * @param calendar
     * @param direction
     */
    calendarPaginate(calendar, direction) {
        calendar.hide();
        calendar = direction === 'next' ? calendar.next() : calendar.prev();
        calendar.show();
    }

    /**
     * Returns the container
     * @return {*}
     */
    getContainer() {
        if (typeof this.container === 'undefined') {
            this.container = $('#content-wrapper');
        }

        if (this.container.length === 0) {
            throw {element: this.container, reason: 'container not found!'};
        }
        return this.container;
    }
}
